// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu3 = () => {
    const { menuDashboard3 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard3?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard3.id,
        title: <FormattedMessage id={`${menuDashboard3.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard3.icon],
        type: menuDashboard3.type,
        children: ChildrenList
    };

    return dashboardList;
};
